import { FormItem, FormLabel } from "@gearbox-protocol/deploy-tools-ui";
import EnvInputs from "components/forms/EnvInputs";
import type { FC } from "react";
import type { ControllerRenderProps } from "react-hook-form";

import type { ForkSchema } from "../schema";

interface ScriptEnvProps {
  field: ControllerRenderProps<ForkSchema, `scripts.${number}.env`>;
}

const ScriptEnv: FC<ScriptEnvProps> = ({ field }) => {
  return (
    <FormItem className="flex flex-row gap-x-1">
      <FormLabel className="w-24 pt-2">Environment variables</FormLabel>

      <EnvInputs field={field} />
    </FormItem>
  );
};

export default ScriptEnv;
